// There are three possible states for our login
// process and we need actions for each of them
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REFRESH = 'LOGIN_REFRESH';
export const HAS_LOGGED_IN = 'HAS_LOGGED_IN';

export const REGISTRATION_REQUEST = 'REGISTRATION_REQUEST';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';

export const SINGLE_REGISTRATION_REQUEST = 'SINGLE_REGISTRATION_REQUEST';
export const SINGLE_REGISTRATION_SUCCESS = 'SINGLE_REGISTRATION_SUCCESS';
export const SINGLE_REGISTRATION_FAILURE = 'SINGLE_REGISTRATION_FAILURE';

export const SINGLE_FREE_REGISTRATION_REQUEST =
  'SINGLE_FREE_REGISTRATION_REQUEST';
export const SINGLE_FREE_REGISTRATION_SUCCESS =
  'SINGLE_FREE_REGISTRATION_SUCCESS';
export const SINGLE_FREE_REGISTRATION_FAILURE =
  'SINGLE_FREE_REGISTRATION_FAILURE';

export const VALIDATE_TRIAL_TOKEN_REQUEST = 'VALIDATE_TRIAL_TOKEN_REQUEST';
export const VALIDATE_TRIAL_TOKEN_SUCCESS = 'VALIDATE_TRIAL_TOKEN_SUCCESS';
export const VALIDATE_TRIAL_TOKEN_FAILURE = 'VALIDATE_TRIAL_TOKEN_FAILURE';

export const TRIAL_REGISTRATION_REQUEST = 'TRIAL_REGISTRATION_REQUEST';
export const TRIAL_REGISTRATION_SUCCESS = 'TRIAL_REGISTRATION_SUCCESS';
export const TRIAL_REGISTRATION_FAILURE = 'TRIAL_REGISTRATION_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const PASSWORD_EMAIL_REQUEST = 'PASSWORD_EMAIL_REQUEST';
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';

export const EXERCISE_REQUEST = 'EXERCISE_REQUEST';
export const EXERCISE_SUCCESS = 'EXERCISE_SUCCESS';
export const EXERCISE_FAILURE = 'EXERCISE_FAILURE';
export const EXERCISE_CREATE_REQUEST = 'EXERCISE_CREATE_REQUEST';
export const EXERCISE_CREATE_SUCCESS = 'EXERCISE_CREATE_SUCCESS';
export const EXERCISE_CREATE_FAILURE = 'EXERCISE_CREATE_FAILURE';
export const EXERCISE_UPDATE_REQUEST = 'EXERCISE_UPDATE_REQUEST';
export const EXERCISE_UPDATE_SUCCESS = 'EXERCISE_UPDATE_SUCCESS';
export const EXERCISE_UPDATE_FAILURE = 'EXERCISE_UPDATE_FAILURE';
export const EXERCISE_DELETE_REQUEST = 'EXERCISE_DELETE_REQUEST';
export const EXERCISE_DELETE_SUCCESS = 'EXERCISE_DELETE_SUCCESS';
export const EXERCISE_DELETE_FAILURE = 'EXERCISE_DELETE_FAILURE';

export const LAUNCH_EXERCISE = 'LAUNCH_EXERCISE';
export const CLEAR_EXERCISE = 'CLEAR_EXERCISE';

export const LAUNCH_TEXT = 'LAUNCH_TEXT';
export const SELECT_TEXT = 'SELECT_TEXT';
export const CLEAR_TEXT = 'CLEAR_TEXT';
export const UPDATE_SOURCE = 'UPDATE_SOURCE';
export const UPDATE_TRANSLATION = 'UPDATE_TRANSLATION';
export const PREV_SENTENCE = 'PREV_SENTENCE';
export const NEXT_SENTENCE = 'NEXT_SENTENCE';
export const SPLICE_SENTENCE = 'SPLICE_SENTENCE';
export const SET_UTTERANCE_LENGTH = 'SET_UTTERANCE_LENGTH';
export const SET_RECORDING = 'SET_RECORDING';
export const ADD_RESULTS = 'ADD_RESULTS';

export const ADD_HISTORY = 'ADD_HISTORY';
export const HISTORY_REPORT_REQUEST = 'HISTORY_REPORT_REQUEST';
export const HISTORY_REPORT_SUCCESS = 'HISTORY_REPORT_SUCCESS';
export const HISTORY_REPORT_FAILURE = 'HISTORY_REPORT_FAILURE';

export const CHANGE_SETTINGS_REQUEST = 'CHANGE_SETTINGS_REQUEST';
export const CHANGE_SETTINGS_SUCCESS = 'CHANGE_SETTINGS_SUCCESS';
export const CHANGE_SETTINGS_FAILURE = 'CHANGE_SETTINGS_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const VALIDATE_TOKEN_REQUEST = 'VALIDATE_TOKEN_REQUEST';
export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';
export const VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE';

export const VALIDATE_EMAIL_REQUEST = 'VALIDATE_EMAIL_REQUEST';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';
export const VALIDATE_EMAIL_FAILURE = 'VALIDATE_EMAIL_FAILURE';

export const JOIN_GROUP_REQUEST = 'JOIN_GROUP_REQUEST';
export const JOIN_GROUP_SUCCESS = 'JOIN_GROUP_SUCCESS';
export const JOIN_GROUP_FAILURE = 'JOIN_GROUP_FAILURE';

export const GROUP_REQUEST = 'GROUP_REQUEST';
export const GROUP_SUCCESS = 'GROUP_SUCCESS';
export const GROUP_FAILURE = 'GROUP_FAILURE';
export const GROUP_UPDATE_REQUEST = 'GROUP_UPDATE_REQUEST';
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS';
export const GROUP_UPDATE_FAILURE = 'GROUP_UPDATE_FAILURE';
export const GROUP_TOKEN_REFRESH_REQUEST = 'GROUP_TOKEN_REFRESH_REQUEST';
export const GROUP_TOKEN_REFRESH_SUCCESS = 'GROUP_TOKEN_REFRESH_SUCCESS';
export const GROUP_TOKEN_REFRESH_FAILURE = 'GROUP_TOKEN_REFRESH_FAILURE';
export const GROUP_USERS_REQUEST = 'GROUP_USERS_REQUEST';
export const GROUP_USERS_SUCCESS = 'GROUP_USERS_SUCCESS';
export const GROUP_USERS_FAILURE = 'GROUP_USERS_FAILURE';

export const GROUP_USER_UPDATE_REQUEST = 'GROUP_USER_UPDATE_REQUEST';
export const GROUP_USER_UPDATE_SUCCESS = 'GROUP_USER_UPDATE_SUCCESS';
export const GROUP_USER_UPDATE_FAILURE = 'GROUP_USER_UPDATE_FAILURE';
export const GROUP_USER_REMOVE_REQUEST = 'GROUP_USER_REMOVE_REQUEST';
export const GROUP_USER_REMOVE_SUCCESS = 'GROUP_USER_REMOVE_SUCCESS';
export const GROUP_USER_REMOVE_FAILURE = 'GROUP_USER_REMOVE_FAILURE';
export const GROUP_SEND_INVITATION_REQUEST = 'GROUP_SEND_INVITATION_REQUEST';
export const GROUP_SEND_INVITATION_SUCCESS = 'GROUP_SEND_INVITATION_SUCCESS';
export const GROUP_SEND_INVITATION_FAILURE = 'GROUP_SEND_INVITATION_FAILURE';

// Payment integration
//

export const PLAN_REQUEST = 'PLAN_REQUEST';
export const PLAN_SUCCESS = 'PLAN_SUCCESS';
export const PLAN_FAILURE = 'PLAN_FAILURE';

export const CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAILURE = 'CREATE_SUBSCRIPTION_FAILURE';

export const RESUME_SUBSCRIPTION_REQUEST = 'RESUME_SUBSCRIPTION_REQUEST';
export const RESUME_SUBSCRIPTION_SUCCESS = 'RESUME_SUBSCRIPTION_SUCCESS';
export const RESUME_SUBSCRIPTION_FAILURE = 'RESUME_SUBSCRIPTION_FAILURE';

export const SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTIONS_REQUEST';
export const SUBSCRIPTIONS_SUCCESS = 'SUBSCRIPTIONS_SUCCESS';
export const SUBSCRIPTIONS_FAILURE = 'SUBSCRIPTIONS_FAILURE';

export const INVOICES_REQUEST = 'INVOICES_REQUEST';
export const INVOICES_SUCCESS = 'INVOICES_SUCCESS';
export const INVOICES_FAILURE = 'INVOICES_FAILURE';

export const UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST';
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS';
export const UPDATE_CARD_FAILURE = 'UPDATE_CARD_FAILURE';

export const CLAIM_COUPON_REQUEST = 'CLAIM_COUPON_REQUEST';
export const CLAIM_COUPON_SUCCESS = 'CLAIM_COUPON_SUCCESS';
export const CLAIM_COUPON_FAILURE = 'CLAIM_COUPON_FAILURE';

export const CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE';

export const GET_INVOICE_REQUEST = 'GET_INVOICE_REQUEST';
export const GET_INVOICE_SUCCESS = 'GET_INVOICE_SUCCESS';
export const GET_INVOICE_FAILURE = 'GET_INVOICE_FAILURE';



// WEBPACK FOOTER //
// ./src/types/index.js